module.exports = __webpack_public_path__ + "img/plusIconBlue.4b0b7d3d.svg";